const yoflags = require('@yola/yoflagsjs');
const config = require('../helpers/config');

const AI_LOCALIZATION_FEATURE_ITEM_ID = 'ai-localization';


const hideFeaturesUnderFeatureFlags = async (isUserUnauthorized) => {
  const apiUrl = config.get('publicApi');
  let data = {};

  try {
    const { visitorFlags, userFlags } = await yoflags.initWith(apiUrl);

    if (isUserUnauthorized) {
      ({ data } = await visitorFlags());
    } else {
      // as we use http protocol to run yolacom localy this request
      // does not work localy because of Yola cookie Secure
      ({ data: { data } } = await userFlags('ai_localization'));
    }
  } catch (error) {
    console.error(error);
  }
  
  const { ai_localization: isAiLocalizationEnabled } = data;

  if (!isAiLocalizationEnabled) {
    const aiLocalizationFeatureItems = document.querySelectorAll(`#${AI_LOCALIZATION_FEATURE_ITEM_ID}`);
    
    aiLocalizationFeatureItems.forEach((item) => item.remove());
  }
};

module.exports = hideFeaturesUnderFeatureFlags;
